﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clients_1 = require("../clients");
const JwtStorage_1 = require("./JwtStorage");
class JwtManager {
    constructor(storage = null) {
        this.storage = storage ? storage : new JwtStorage_1.JwtStorage();
    }
    save(rawToken) {
        let payload = this.read(rawToken);
        this.storage.saveToken(rawToken);
        return payload;
    }
    getRawToken() {
        return this.storage.readToken();
    }
    forget() {
        this.storage.removeToken();
    }
    validateToken() {
        return this.storage.readToken() !== null;
    }
    read(value) {
        try {
            let parts = value.split('.');
            let rawPayload = JSON.parse(this.decode64(parts[1]));
            return {
                username: rawPayload[clients_1.CustomClaimTypeName.Name],
                organizationAppId: rawPayload[clients_1.CustomClaimTypeName.Org],
                permissions: this.getArray(rawPayload[clients_1.CustomClaimTypeName.Prms]),
                visibleOrganizations: this.getArray(rawPayload[clients_1.CustomClaimTypeName.Vorgs]).map(vorg => {
                    let tempVOrg = JSON.parse(vorg);
                    return {
                        organizationAppId: tempVOrg[clients_1.VisibleOrganizationTokenName.Org],
                        editable: tempVOrg[clients_1.VisibleOrganizationTokenName.Edit]
                    };
                })
            };
        }
        catch (e) {
            console.error(`[${new Date()}] JwtManager.read() => Invalid token: ${value}`);
            console.error(`[${new Date()}] JwtManager.read() => Invalid token error: ${e}`);
            throw Error(`Invalid token ${value}`);
        }
    }
    decode64(value) {
        return decodeURIComponent(escape(atob(value)));
    }
    getArray(values) {
        if (!values) {
            return [];
        }
        else if (values instanceof Array) {
            return [...values];
        }
        else {
            return [values];
        }
    }
}
exports.JwtManager = JwtManager;
//# sourceMappingURL=JwtManager.js.map